import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/vi-logo-title.png'
import _imports_1 from '@/assets/images/vi-logo-title-p3.png'


_pushScopeId("data-v-babb2fd6")
const _hoisted_1 = { class: "scrm-logo" }
const _hoisted_2 = {
  key: 0,
  style: {"width":"54px"},
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  style: {"width":"40px"},
  src: _imports_1,
  alt: ""
}
const _hoisted_4 = { class: "hasRadius main-menu-area" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftMenu = _resolveComponent("LeftMenu")!
  const _component_SubMenu = _resolveComponent("SubMenu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ width: !_ctx.menu_isCollapse ? '323px' : '75px' }),
    class: "left-nav-body"
  }, [
    (!_ctx.menu_isCollapse)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "left-nav-mask",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCloseLeftNav && _ctx.handleCloseLeftNav(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.is3Part && _ctx.showLogo)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.is3Part)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_LeftMenu, {
        onOnMenuSelect: _ctx.onParentSelect,
        onOnHandlePicGuide: _ctx.handlePicGuide
      }, null, 8, ["onOnMenuSelect", "onOnHandlePicGuide"])
    ]),
    (!_ctx.menu_isCollapse)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        overflowX: 'hidden',
      },
          class: _normalizeClass(_ctx.menu_isCollapse ? 'open-collapse' : 'close-collapse')
        }, [
          (_ctx.menu.length > 0)
            ? (_openBlock(), _createBlock(_component_el_menu, {
                key: 0,
                collapse: false,
                "default-active": _ctx.defaultActive,
                "background-color": "rgba(144, 100, 255, 0.1)",
                "text-color": "rgba(255, 255, 255, 1)",
                "active-text-color": "#434AF9",
                "collapse-transition": false,
                style: _normalizeStyle({ width: _ctx.finalWidth, marginLeft: '21px' }),
                class: _normalizeClass(_ctx.menu_isCollapse ? 'open-collapse second-menu' : 'close-collapse')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "nav-line",
                      style: _normalizeStyle({ width: _ctx.finalWidth })
                    }, [
                      _createVNode(_component_SubMenu, {
                        submenu: item,
                        index: item.key
                      }, null, 8, ["submenu", "index"])
                    ], 4))
                  }), 128))
                ]),
                _: 1
              }, 8, ["default-active", "style", "class"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 4))
}